import type { ChatState, ChatAction } from './types'

const initialState: ChatState = {
  messages: [],
  isLoading: false,
  error: null,
  generatedResume: null,
  initialized: false,
  initializationInProgress: false,
}

const chatReducer = (state = initialState, action: ChatAction): ChatState => {
  switch (action.type) {
    case 'INITIALIZE_CHAT':
      return {
        ...state,
        initializationInProgress: true,
      }

    case 'SEND_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload],
        error: null,
        initialized: true,
        initializationInProgress: false,
      }

    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload,
      }

    case 'SET_ERROR':
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }

    case 'SET_GENERATED_RESUME':
      return {
        ...state,
        generatedResume: action.payload,
      }

    default:
      return state
  }
}

export default chatReducer
